/* sk-product.js — Silberkraft-PDP auf Horizon (sections/sk-product-information.liquid), 30.10.2026.
   Ersetzt die Empire-PDP-Logik (empire.min.js, Flickity, sk-gallery-nav.js) ohne jQuery:
   - Galerie: Vorschaubilder, Pfeile + Wischen (< 720 px, wie Empire), Zähler, Variantenbild
   - Variantenwahl: Listview/Swatches → Variante → Section Rendering API (?variant=&section_id=) → Bereiche [data-sk-swap] aktualisieren
   - Warenkorb: /cart/add.js + CartLinesUpdateEvent (@shopify/events) → Horizon-Drawer bzw. sk-drawer (sk-cart-bridge) öffnen
   - Kompatibilität: feuert 'variant-change' auf <variant-selection> (Empire-Ereignis, u. a. sk-amazon-abverkauf) */

const MOBILE_SLIDER = window.matchMedia('(max-width: 719px)');

function money(text) {
  return (text || '').trim();
}

class SkGallery {
  constructor(root) {
    this.root = root;
    this.viewer = root.querySelector('[data-gallery-viewer]');
    this.figures = Array.from(root.querySelectorAll('[data-gallery-figure]'));
    this.thumbs = Array.from(root.querySelectorAll('[data-gallery-thumbnail]'));
    this.scroller = root.querySelector('[data-gallery-scroller]');
    root.querySelector('[data-gallery-navigation]')?.classList.remove('loading');
    this.index = Math.max(0, this.figures.findIndex((f) => f.dataset.gallerySelected === 'true'));
    this.thumbs.forEach((t) => t.addEventListener('click', (e) => { e.preventDefault(); this.select(Number(t.dataset.galleryIndex) || 0); }));
    root.querySelectorAll('[data-gallery-scroll-button]').forEach((b) => b.addEventListener('click', () => {
      if (!this.scroller) return;
      const dir = b.classList.contains('scroll-left') ? -1 : 1;
      this.scroller.scrollBy({ left: dir * this.scroller.clientWidth * 0.8, behavior: 'smooth' });
    }));
    if (this.figures.length > 1) this.#mobileControls();
    const lazyPosters = () => setTimeout(() => SkGallery.posters(root), 1500);
    if (document.readyState === 'complete') lazyPosters(); else window.addEventListener('load', lazyPosters, { once: true });
    root.querySelectorAll('[data-sk-video-play]').forEach((b) => b.addEventListener('click', (e) => {
      e.preventDefault(); e.stopPropagation();
      const v = b.parentElement.querySelector('video');
      if (!v) return;
      SkGallery.posters(b.parentElement);
      v.controls = true; v.muted = false;
      b.hidden = true;
      v.play().catch(() => { v.muted = true; v.play().catch(() => {}); });
    }));
    /* Klick-Zoom wie Empire (gallery_click_to_zoom „always“): Bild groß im Dialog, Pfeile/Wischen/Esc */
    this.viewer?.addEventListener('click', (e) => {
      if (e.target instanceof Element && e.target.closest('.sk-arrow, video, button, a, iframe, model-viewer')) return;
      const f = this.figures[this.index];
      if (f && f.dataset.mediaType === 'image') this.openZoom();
    });
  }

  openZoom() {
    const host = this.root.closest('sk-product') || document.body;
    const L = host.dataset || {};
    let d = document.querySelector('dialog.sk-zoom');
    if (!d) {
      d = document.createElement('dialog');
      d.className = 'sk-zoom';
      d.innerHTML = `<button type="button" class="sk-zoom__close" aria-label="${L.skCloseLabel || ''}">×</button><button type="button" class="sk-zoom__nav sk-zoom__nav--prev" aria-label="${L.skPrevLabel || ''}">‹</button><img class="sk-zoom__img" alt=""><button type="button" class="sk-zoom__nav sk-zoom__nav--next" aria-label="${L.skNextLabel || ''}">›</button>`;
      document.body.append(d);
      d.addEventListener('click', (e) => { if (e.target === d || e.target.classList.contains('sk-zoom__close')) d.close(); });
      let x0 = null;
      d.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      d.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) d._step(dx < 0 ? 1 : -1); }, { passive: true });
      d.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') d._step(1); if (e.key === 'ArrowLeft') d._step(-1); });
      d.querySelector('.sk-zoom__nav--prev').addEventListener('click', () => d._step(-1));
      d.querySelector('.sk-zoom__nav--next').addEventListener('click', () => d._step(1));
    }
    const show = () => {
      const f = this.figures[this.index];
      const img = f.querySelector('img');
      d.querySelector('.sk-zoom__img').src = f.dataset.zoom || img?.currentSrc || img?.src || '';
      d.querySelector('.sk-zoom__img').alt = img?.alt || '';
    };
    d._step = (dir) => {
      const n = this.figures.length; let i = this.index;
      for (let k = 0; k < n; k++) { i = (i + dir + n) % n; if (this.figures[i].dataset.mediaType === 'image') break; }
      this.select(i); show();
    };
    show();
    d.showModal();
  }

  #mobileControls() {
    if (!this.viewer) return;
    const mk = (cls, label, points) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = `sk-arrow ${cls}`;
      b.setAttribute('aria-label', label);
      b.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="${points}"/></svg>`;
      return b;
    };
    const labels = this.root.dataset;
    this.prev = mk('sk-arrow--prev', labels.skPrevLabel || '‹', '15 18 9 12 15 6');
    this.next = mk('sk-arrow--next', labels.skNextLabel || '›', '9 18 15 12 9 6');
    this.prev.addEventListener('click', (e) => { e.preventDefault(); this.step(-1); });
    this.next.addEventListener('click', (e) => { e.preventDefault(); this.step(1); });
    this.viewer.append(this.prev, this.next);
    this.counter = document.createElement('span');
    this.counter.className = 'sk-counter';
    this.counter.setAttribute('aria-hidden', 'true');
    this.viewer.append(this.counter);
    this.#updateCounter();
    let x0 = null, y0 = null;
    this.viewer.addEventListener('touchstart', (e) => { const t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
    this.viewer.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) this.step(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  #updateCounter() {
    if (this.counter) this.counter.textContent = `${this.index + 1} / ${this.figures.length}`;
  }

  /* Video-Poster: Liquid setzt nur beim gewählten Video „poster“, sonst data-sk-poster (Ladezeit) — früher hat empire.js das nachgeholt */
  static posters(scope) {
    scope.querySelectorAll('video[data-sk-poster]').forEach((v) => { v.poster = v.dataset.skPoster; v.removeAttribute('data-sk-poster'); });
  }

  step(dir) {
    const n = this.figures.length;
    this.select((this.index + dir + n) % n);
  }

  selectMedia(mediaId) {
    const i = this.figures.findIndex((f) => f.dataset.media === String(mediaId));
    if (i >= 0) this.select(i);
  }

  select(i) {
    if (!this.figures[i]) return;
    this.index = i;
    this.figures.forEach((f, k) => {
      const on = k === i;
      f.dataset.gallerySelected = on ? 'true' : 'false';
      f.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (!on) f.querySelectorAll('video').forEach((v) => v.pause());
      if (on) f.querySelectorAll('img[loading="lazy"]').forEach((img) => img.setAttribute('loading', 'eager'));
      if (on) SkGallery.posters(f);
    });
    this.thumbs.forEach((t) => {
      const on = Number(t.dataset.galleryIndex) === i;
      t.dataset.gallerySelected = on ? 'true' : 'false';
      if (on && this.scroller) {
        const l = t.offsetLeft - (this.scroller.clientWidth - t.offsetWidth) / 2;
        this.scroller.scrollTo({ left: Math.max(0, l), behavior: 'smooth' });
      }
    });
    this.#updateCounter();
  }
}

class SkProduct extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;
    try {
      this.variants = JSON.parse(this.querySelector('[data-sk-variants]')?.textContent || '[]');
    } catch (e) {
      this.variants = [];
    }
    const g = this.querySelector('[data-product-gallery]');
    if (g) this.gallery = new SkGallery(g);
    this.form = this.querySelector('form[data-sk-product-form]');
    this.select = this.form?.querySelector('select[name="id"][data-variants]');
    this.addEventListener('change', (e) => this.#onChange(e));
    /* Schlupfwespen-Kartenauswahl setzt die Variante per Klick auf die Zeile (ohne change-Ereignis am Radio) */
    this.addEventListener('click', (e) => {
      const row = e.target instanceof Element ? e.target.closest('[data-vid]') : null;
      if (!row) return;
      setTimeout(() => {
        const v = this.variants.find((x) => String(x.id) === row.dataset.vid);
        if (v) this.selectVariant(v);
      }, 0);
    });
    this.form?.addEventListener('submit', (e) => this.#onSubmit(e));
  }

  #currentOptions() {
    const out = [];
    this.querySelectorAll('[data-variant-option-value]').forEach((inp) => {
      const idx = Number(inp.dataset.variantOptionValueIndex || 0);
      if ((inp.type === 'radio' && inp.checked) || inp.tagName === 'SELECT') out[idx] = inp.value;
    });
    return out;
  }

  #onChange(e) {
    const t = e.target;
    if (!(t instanceof HTMLElement)) return;
    /* Schlupfwespen-Kartenauswahl (snippets/schlupfwespen-card-selector): Zeilen tragen die Varianten-ID direkt */
    const vidRow = t.closest('[data-vid]');
    if (vidRow) {
      const v = this.variants.find((x) => String(x.id) === vidRow.dataset.vid);
      if (v) this.selectVariant(v);
      return;
    }
    if (!t.matches('[data-variant-option-value]')) return;
    const opts = this.#currentOptions();
    const v = this.variants.find((x) => x.o.every((val, i) => opts[i] === undefined || opts[i] === val));
    if (v) this.selectVariant(v);
  }

  selectVariant(v) {
    if (String(v.id) === this.dataset.variantId) return;
    this.dataset.variantId = String(v.id);
    if (this.select && !this.select.disabled) this.select.value = String(v.id);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    history.replaceState(history.state, '', url.toString());
    if (v.m && this.gallery) this.gallery.selectMedia(v.m);
    const vs = this.querySelector('variant-selection');
    vs?.setAttribute('variant', String(v.id));
    vs?.dispatchEvent(new CustomEvent('variant-change', { detail: { product: { id: Number(this.dataset.productId) }, variant: { id: v.id, available: v.a, title: v.t }, state: v.id } }));
    this.#refresh(v.id);
  }

  async #refresh(variantId) {
    this._abort?.abort();
    this._abort = new AbortController();
    const base = this.dataset.productUrl;
    try {
      const res = await fetch(`${base}?variant=${variantId}&section_id=${this.dataset.sectionId}`, { signal: this._abort.signal });
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const scope = this.closest('.sk-pdp-section') || this;
      scope.querySelectorAll('[data-sk-swap]').forEach((el) => {
        const name = el.dataset.skSwap;
        const fresh = doc.querySelector(`[data-sk-swap="${name}"]`);
        if (!fresh) return;
        for (const a of Array.from(el.attributes)) if (!fresh.hasAttribute(a.name)) el.removeAttribute(a.name);
        for (const a of Array.from(fresh.attributes)) if (el.getAttribute(a.name) !== a.value) el.setAttribute(a.name, a.value);
        if (el.innerHTML !== fresh.innerHTML) el.innerHTML = fresh.innerHTML;
      });
      /* Galerie: Variantenbild (featured_media) wie live – Empire zeigt bei hide_variant_image nur das Bild der gewählten
         Variante als erste Folie; die neu gerenderte Galerie bringt genau diese Folie mit. */
      const g = this.querySelector('[data-product-gallery]');
      const ng = doc.querySelector('[data-product-gallery]');
      if (g && ng) {
        const keepIdx = this.gallery ? this.gallery.index : 0;
        const vFig = ng.querySelector('[data-gallery-figure][data-gallery-selected="true"]') || ng.querySelector('.product-gallery--media-variant-viewer');
        g.replaceWith(ng);
        this.gallery = new SkGallery(ng);
        const target = vFig ? Number(vFig.dataset.galleryIndex) : keepIdx;
        this.gallery.select(Number.isFinite(target) ? target : 0);
      }
      this.dispatchEvent(new CustomEvent('sk:variant-rendered', { bubbles: true, detail: { variantId } }));
    } catch (e) {
      if (e.name !== 'AbortError') console.warn('[sk-product] refresh', e);
    }
  }

  async #onSubmit(e) {
    const form = this.form;
    if (!form || !window.fetch) return;
    e.preventDefault();
    const btn = form.querySelector('[data-product-atc]');
    const err = form.querySelector('[data-sk-atc-error]');
    if (btn?.disabled) return;
    btn?.classList.add('processing');
    btn?.setAttribute('aria-busy', 'true');
    if (err) err.hidden = true;
    const fd = new FormData(form);
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]')).map((c) => c.dataset.sectionId);
    if (sectionIds.length) fd.append('sections', sectionIds.join(','));
    const id = String(fd.get('id') || '');
    const quantity = Number(fd.get('quantity')) || 1;
    let ev = null, deferred = null;
    try {
      const m = await import('@shopify/events');
      deferred = m.CartLinesUpdateEvent.createPromise();
      ev = m.CartLinesUpdateEvent;
      this.dispatchEvent(new m.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: id, quantity }], promise: deferred.promise }));
    } catch (_) { /* Events-Modul nicht verfügbar → nur Warenkorb-API */ }
    const addUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
    try {
      /* 429/5xx (Drosselung): einmal kurz warten und wiederholen, erst dann klassisch absenden */
      const post = () => fetch(addUrl, { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      let r = await post();
      if (r.status === 429 || r.status >= 500) { await new Promise((ok) => setTimeout(ok, 1500)); r = await post(); }
      if (r.status === 429) {
        /* Shop drosselt: Hinweis statt Formular-Fallback (der würde ebenfalls 429 liefern und auf eine Fehlerseite führen) */
        if (err) { err.textContent = err.dataset.skRateText || ''; err.hidden = false; }
        deferred?.reject(new Error('429'));
        return;
      }
      const data = await r.json();
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((x) => x.json()).catch(() => ({ items: [], item_count: 0 }));
      if (data.status) {
        if (err) { err.textContent = data.description || data.message || ''; err.hidden = false; }
        deferred?.resolve({ cart: ev.createCartFromAjaxResponse(cart), detail: { didError: true, items: cart.items, source: 'sk-product', sourceId: this.dataset.sectionId, itemCount: quantity, productId: this.dataset.productId } });
      } else {
        deferred?.resolve({ cart: ev.createCartFromAjaxResponse(cart), detail: { didError: false, items: cart.items, source: 'sk-product', sourceId: this.dataset.sectionId, itemCount: quantity, productId: this.dataset.productId, sections: data.sections } });
        if (!deferred) window.location.href = '/cart';
      }
    } catch (x) {
      deferred?.reject(x);
      form.submit();
    } finally {
      btn?.classList.remove('processing');
      btn?.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('sk-product')) customElements.define('sk-product', SkProduct);


/* Nachladen beim Scrollen (Empfehlungen): ersetzt den Inhalt durch dieselbe Section mit Shopify-Empfehlungen */
class SkPdpLazy extends HTMLElement {
  connectedCallback() {
    const url = this.dataset.url;
    if (!url || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      io.disconnect();
      fetch(url).then((r) => (r.ok ? r.text() : '')).then((html) => {
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector(this.tagName.toLowerCase());
        if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
      }).catch(() => {});
    }, { rootMargin: '400px 0px' });
    io.observe(this);
  }
}
if (!customElements.get('sk-pdp-lazy')) customElements.define('sk-pdp-lazy', SkPdpLazy);

/* Zuletzt angesehen: IDs in localStorage, Karten per Suche + Section Rendering */
class SkPdpRecent extends HTMLElement {
  connectedCallback() {
    const KEY = 'sk_recently_viewed';
    const pid = this.dataset.productId;
    let ids = [];
    try { ids = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (_) {}
    const others = ids.filter((x) => x !== pid).slice(0, 6);
    try { localStorage.setItem(KEY, JSON.stringify([pid, ...ids.filter((x) => x !== pid)].slice(0, 12))); } catch (_) {}
    if (!others.length) return;
    const q = others.map((x) => `id:${x}`).join(' OR ');
    const io = new IntersectionObserver((entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      io.disconnect();
      fetch(`/search?q=${encodeURIComponent(q)}&type=product&section_id=${this.dataset.sectionId}`)
        .then((r) => (r.ok ? r.text() : ''))
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('sk-pdp-recent');
          if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
        }).catch(() => {});
    }, { rootMargin: '400px 0px' });
    io.observe(this);
  }
}
if (!customElements.get('sk-pdp-recent')) customElements.define('sk-pdp-recent', SkPdpRecent);

/* ---- 30.10.2026 (fable-opt): vorher Inline-Scripts in den Snippets (Listview-Toggle, Vorteile-Rotator, Typewriter) ---- */
/* Mengenvorteil-Liste: „Alle N Optionen“ auf/zu, Kopfzeile = gewählte Variante, Auto-Aufklappen bei versteckter Auswahl */
function initSklLists(scope) {
  /* Einheitlich für alle Mengenstaffeln (Listview, Schlupfwespen-Karten …), Philipp 30.10.2026:
     eingeklappt 4 Zeilen (mobil + Desktop, vorher 2/3) + Bestseller-Zeile + immer die GEWÄHLTE Zeile; Toggle-Text über data-skl-expanded,
     aria-expanded/aria-controls am Button. Kein Auto-Aufklappen mehr nötig (gewählte Zeile bleibt sichtbar). */
  (scope || document).querySelectorAll('.skl').forEach((skl) => {
    if (skl.__skInit) return;
    skl.__skInit = 1;
    const btn = skl.querySelector('[data-skl-toggle]');
    const hd = skl.querySelector('[data-selected-variant-title]');
    const list = skl.querySelector('.skl__list');
    const rows = Array.from(skl.querySelectorAll('.skl__list > .skl__row'));
    const mq = window.matchMedia('(max-width: 768px)');
    const apply = () => {
      const open = skl.getAttribute('data-skl-expanded') === 'true';
      const visible = 4; /* Philipp 30.10. abends: mobil + Desktop immer 4 Zeilen, Toggle erst ab 5 */
      let hidden = 0;
      rows.forEach((r, i) => {
        const keep = open || i < visible || r.matches('.skl__row--best, .skl__row--rec') || !!r.querySelector('[class*="badge"]') || !!r.querySelector('input:checked');
        r.classList.toggle('skl__row--collapsed', !keep);
        if (!keep) hidden++;
      });
      if (btn) btn.hidden = !open && hidden === 0;
    };
    const setExpanded = (on) => { skl.setAttribute('data-skl-expanded', on ? 'true' : 'false'); if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false'); apply(); };
    skl.setAttribute('data-skl-js', '');
    if (list && btn) { if (!list.id) list.id = 'skl-list-' + Math.random().toString(36).slice(2, 8); btn.setAttribute('aria-controls', list.id); }
    btn?.addEventListener('click', (e) => { e.preventDefault(); e.stopImmediatePropagation(); setExpanded(skl.getAttribute('data-skl-expanded') !== 'true'); });
    skl.addEventListener('change', (e) => {
      const radio = e.target;
      if (!(radio instanceof HTMLInputElement) || !radio.checked) return;
      const t = radio.closest('.skl__row')?.getAttribute('data-formatted-title');
      if (t && hd) hd.textContent = t;
      apply();
    });
    skl.addEventListener('click', (e) => { if (e.target instanceof Element && e.target.closest('.skl__row')) setTimeout(apply, 0); });
    mq.addEventListener?.('change', apply);
    setExpanded(skl.getAttribute('data-skl-expanded') === 'true');
  });
}
/* Vorteile-Box unter dem Kaufbutton: eine Zeile sichtbar, wechselt alle 3 s (reduced motion: Liste) */
function initUspRotators(scope) {
  (scope || document).querySelectorAll('[data-sk-usp]').forEach((box) => {
    if (box.getAttribute('data-sk-usp-ready')) return;
    box.setAttribute('data-sk-usp-ready', '1');
    const list = box.querySelector('.sk-usp__list');
    const n = list ? list.children.length : 0;
    if (n < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { box.classList.add('sk-usp--static'); return; }
    const clone = list.children[0].cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    list.appendChild(clone);
    let i = 0; let paused = false;
    box.addEventListener('mouseenter', () => { paused = true; });
    box.addEventListener('mouseleave', () => { paused = false; });
    list.addEventListener('transitionend', () => {
      if (i < n) return;
      list.style.transition = 'none'; i = 0; list.style.setProperty('--sk-usp-i', 0);
      void list.offsetHeight; list.style.transition = '';
    });
    setInterval(() => { if (paused || document.hidden) return; i += 1; list.style.setProperty('--sk-usp-i', i); }, 3000);
  });
}
/* Typewriter „Anwendungsgebiete: 🦋 Kleidermotten“ – tippt pro Graphem (Emoji = Surrogatpaar), ein Takt für alle Instanzen */
function initTypewriters() {
  const src = document.querySelector('.sk-tw[data-sk-tw]');
  if (!src || window.__skTw) return;
  let items = [];
  try { items = JSON.parse(src.getAttribute('data-sk-tw') || '[]'); } catch (_) { return; }
  if (items.length < 2) return;
  window.__skTw = 1;
  const graphemes = (str) => { try { if (Intl.Segmenter) return Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(str), (s) => s.segment); } catch (_) {} return Array.from(str); };
  const words = items.map(graphemes);
  const els = () => document.querySelectorAll('.sk-tw__text');
  let idx = 0; let charIdx = words[0].length; let deleting = false;
  const pauseMs = 2000; const typeMs = 50; const deleteMs = 25;
  const set = (t) => els().forEach((e) => { e.textContent = t; });
  set(items[0]);
  function tick() {
    const word = words[idx];
    if (!deleting) {
      charIdx++; set(word.slice(0, charIdx).join(''));
      if (charIdx >= word.length) { setTimeout(() => { deleting = true; tick(); }, pauseMs); return; }
      setTimeout(tick, typeMs);
    } else {
      charIdx--; set(word.slice(0, charIdx).join(''));
      if (charIdx <= 0) { deleting = false; idx = (idx + 1) % items.length; setTimeout(tick, 200); return; }
      setTimeout(tick, deleteMs);
    }
  }
  setTimeout(() => { deleting = true; tick(); }, pauseMs);
}
/* Pflanzen-Mengenmatrix/-Kaufbox (assets/sk-plant-qm.js, sk-plant.js) melden die gewählte Größe per „sk-plant:variant“.
   Empire hat das über <variant-selection variant=…> übernommen; in Horizon setzt sk-product die Variante:
   ?variant= (replaceState), Formular-ID, Galerie (variant.featured_media), Preis/Grundpreis/Lager per Section Rendering (30.10.2026, GMC). */
document.addEventListener('sk-plant:variant', (e) => {
  const d = e.detail || {};
  if (!d.id) return;
  const sec = d.sectionId ? document.getElementById(`shopify-section-${d.sectionId}`) : null;
  const sp = sec?.querySelector('sk-product') || document.querySelector('sk-product');
  const v = sp?.variants?.find((x) => String(x.id) === String(d.id));
  if (v) sp.selectVariant(v);
});
function skPdpBoot() { initSklLists(); initUspRotators(); initTypewriters(); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', skPdpBoot); else skPdpBoot();
document.addEventListener('shopify:section:load', skPdpBoot);
